<template>
  <div class="siedbar-container">
    <div class="siedbar-box">
      <el-popover placement="left" width="120px" trigger="hover">
        <div class="siedbar-booking">预约试用</div>

        <div class="edit-box" slot="reference">
          <img
            class="icon"
            :src="require('@/assets/images/HomePage/siedbar/填写.png')"
            alt="填写图标加载失败"
            @click="bookingVisible = true"
          />
        </div>
      </el-popover>
      <el-popover placement="left" width="190px" trigger="hover">
        <div class="phone-content">咨询电话</div>
        <div class="phone-number">17769553399</div>
        <div class="phone-box" slot="reference">
          <img
            class="icon"
            :src="require('@/assets/images/HomePage/siedbar/电话.png')"
            alt="电话图标加载失败"
          />
        </div>
      </el-popover>
    </div>
    <div class="top-box" @click="scrollToTop" v-if="goTopVisible">
      <div class="top-btn"></div>
    </div>

    <!-- 预约试用 -->
    <div class="booking-container" v-if="bookingVisible">
      <div class="booking-box">
        <Booking class="booking-item"></Booking>
        <img
          class="close"
          :src="require('@/assets/images/HomePage/siedbar/close.png')"
          alt="关闭图标加载失败"
          @click="bookingVisible = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Booking from "@/components/HomePage/Booking.vue";
export default {
  components: {
    Booking,
  },
  data() {
    return {
      bookingVisible: false,
      goTopVisible: false,
    };
  },
  mounted() {
    // 向window对象添加滚动事件监听器，当页面滚动时，会调用handleScroll方法。
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    scrollToTop() {
      // 定义一个内部函数来处理滚动逻辑
      const scrollStep = () => {
        // 获取当前页面滚动的垂直距离
        const c =
          window.scrollY ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;
        if (c > 0) {
          // 滚动一小段距离
          const newScrollPosition = Math.max(0, c - c / 10); // 确保不会滚动到负数位置
          // scrollTo方法，用于将浏览器窗口滚动到指定的位置。这个方法接受两个参数，分别代表水平滚动距离和垂直滚动距离。
          window.scrollTo(0, newScrollPosition);

          // 执行动画并请求浏览器在下次重绘之前调用指定的函数来更新动画的方法
          window.requestAnimationFrame(scrollStep);
        }
      };

      // 启动滚动过程
      scrollStep();
    },
    handleScroll() {
      //处理返回顶部的按钮
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      let screenHeight = window.innerHeight;

      if (scrollTop > screenHeight / 2) this.goTopVisible = true;
      else this.goTopVisible = false;
    },
  },
  beforeDestroy() {
    // 移除之前添加到window对象的滚动事件监听器，防止内存泄漏。
    // 同样地，这里直接使用this.handleScroll作为监听器的引用是可行的，因为Vue的methods方法会绑定到组件实例上。
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
/* 侧边栏 */
.siedbar-container {
  .siedbar-box {
    position: fixed;
    z-index: 100;
    right: 1.25%;
    bottom: 13.7%;
    width: 48px;
    height: 109px;
    background: #0271e3;
    box-shadow: 0 4px 16px 0 #0000001a;
    border-radius: 28px;

    display: flex;
    flex-direction: column;
    align-items: center;

    .edit-box {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      border-radius: 23px;
      margin-top: 6px;

      .icon {
        max-width: 24px;
        max-height: 24px;
        flex: 1;
      }
      &:hover {
        background: #ffffff29;
        cursor: pointer;
      }
    }
    .phone-box {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      border-radius: 23px;
      margin-top: 17px;

      .icon {
        max-width: 24px;
        max-height: 24px;
        flex: 1;
      }
      &:hover {
        background: #ffffff29;
        cursor: pointer;
      }
    }
    .phone-content {
      width: 56px;
      height: 20px;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      letter-spacing: 0;
      line-height: 20px;
    }
  }
  .top-box {
    position: fixed;
    z-index: 100;
    right: 1.25%;
    bottom: 5.56%;
    width: 48px;
    height: 48px;
    background: #fffffff2;
    border-radius: 50%;
    box-shadow: 0 0 16px 0 #0000001a;
    display: flex;
    align-items: center;
    margin: 0;
    flex-shrink: 1;

    .top-btn {
      width: 24px;
      height: 24px;
      margin: 0 auto;
      object-fit: contain;
      background-image: url("@/assets/images/HomePage/siedbar/top.png");
      background-size: cover; /* 覆盖整个容器，图片可能会被裁剪以填满容器 */
      background-position: center; /* 图片居中显示 */
      flex-shrink: 1;
    }
    &:hover {
      cursor: pointer;
      .top-btn {
        background-image: url("@/assets/images/HomePage/siedbar/top-hover.png");
      }
    }
  }
}
/* 预约试用 */
.booking-container {
  width: 100vw;
  height: 100vh;
  background: #00000099;
  backdrop-filter: blur(8px);
  position: fixed;
  z-index: 120;
  top: 0%;
  left: 0%;

  .booking-box {
    position: relative;
    z-index: 121;
    left: 50%;
    top: 50%;
    transform: translate(
      -50%,
      -50%
    ); // 向左和向上移动自身宽高的一半，实现完全居中
    height: 540px;
    max-width: 780px;
    width: 40.6%;
    flex: 1;
    background-color: rgba(255, 255, 255, 0); // 白色背景，50%透明度

    .booking-item {
      width: 100%;
      height: 100%;
    }
    .close {
      position: absolute;
      z-index: 122;
      height: 36px;
      width: 36px;
      flex: 1;
      top: -40px;
      right: -40px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
